import { ReactElement } from 'react';

import { ShieldProtectedIcon, Tooltip, usePush } from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { confidentialityNotificationsTranslationKeys } from '../../../translations';
import { SYSTEM_ACTIVITY_PATH } from '../../../toolbar/UserDropdown';
import { formatBadgeCount } from '../ConfidentialityNotificationsBadge.utils';
import { StyledBadgeCount } from '../Badge.styled';

import { StyledConfidentialityRequestsButton } from './ConfidentialityRequestsIcon.styled';
import { useConfidentialResourceAccessRequestsPendingCount } from './ConfidentialityRequestsIcon.hooks';

export const ConfidentialityRequestsIcon = (): ReactElement => {
   const push = usePush();
   const { data: pendingCount } = useConfidentialResourceAccessRequestsPendingCount();
   const count = pendingCount ?? 0;
   const displayedCount = formatBadgeCount(count);

   return (
      <Tooltip
         testId={'confidentialityRequests'}
         content={<Translate>{confidentialityNotificationsTranslationKeys.pendingRequestsTooltip}</Translate>}
      >
         <StyledConfidentialityRequestsButton
            testId={'confidentialityRequests'}
            type={'button'}
            onClick={() => push(SYSTEM_ACTIVITY_PATH)}
            label={
               <>
                  <ShieldProtectedIcon />
                  {count > 0 ? (
                     <StyledBadgeCount data-testid={'confidentialityRequestsCount'}>{displayedCount}</StyledBadgeCount>
                  ) : null}
               </>
            }
         />
      </Tooltip>
   );
};
